import { DefaultState } from 'store/types';

export const DELETE_AUTOMATED_REPORT_REQUEST = 'DELETE_AUTOMATED_REPORT_REQUEST';
export const DELETE_AUTOMATED_REPORT_SUCCESS = 'DELETE_AUTOMATED_REPORT_SUCCESS';
export const DELETE_AUTOMATED_REPORT_FAILURE = 'DELETE_AUTOMATED_REPORT_FAILURE';

export interface DeleteAutomatedReportData {

};

export type DeleteAutomatedReportState = DefaultState & {
  contents?: DeleteAutomatedReportData;
};

interface DeleteAutomatedReportRequest {
  type: typeof DELETE_AUTOMATED_REPORT_REQUEST;
};

interface DeleteAutomatedReportSuccess {
  type: typeof DELETE_AUTOMATED_REPORT_SUCCESS,
  contents: DeleteAutomatedReportData;
}

interface DeleteAutomatedReportFailure {
  type: typeof DELETE_AUTOMATED_REPORT_FAILURE;
}

export type DeleteAutomatedReportActionTypes = DeleteAutomatedReportRequest | DeleteAutomatedReportSuccess | DeleteAutomatedReportFailure;